import { render, staticRenderFns } from "./GeoCoordinateValue.vue?vue&type=template&id=54af6b58&scoped=true"
import script from "./GeoCoordinateValue.vue?vue&type=script&lang=js"
export * from "./GeoCoordinateValue.vue?vue&type=script&lang=js"
import style0 from "./GeoCoordinateValue.vue?vue&type=style&index=0&id=54af6b58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54af6b58",
  null
  
)

export default component.exports